module.exports = {"350981001":"城南街道","350981002":"城北街道","350981003":"阳头街道","350981004":"罗江街道","350981100":"赛岐镇","350981101":"穆阳镇","350981102":"上白石镇","350981103":"潭头镇","350981104":"社口镇","350981105":"晓阳镇","350981106":"溪潭镇","350981107":"甘棠镇","350981108":"下白石镇","350981109":"溪尾镇","350981110":"溪柄镇","350981111":"湾坞镇","350981112":"城阳镇","350981201":"坂中畲族乡","350981202":"范坑乡","350981203":"穆云畲族乡","350981204":"康厝畲族乡","350981206":"松罗乡","350981501":"福安畲族开发区","350981502":"湾坞工业集中区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350981.json
// module id = 1356
// module chunks = 0